import DataTile from "./DataTile";
import React from "react";
import {useSelector} from "react-redux";
import {BBObjectCounter,
    bbFindEntityWithinPortfolioOrSelf,
} from "../../../util/bbHelpers";
import CustomActiveShapePieChart from "../charts/CustomActiveShapePieChart";


const Tile = ({cycleId=null,}) => {

    // const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView, loadingCycleDetails} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const lastCycle = myEntity
    && myEntity.cycles
    && myEntity.settings
    && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;

    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;
    const showPieWith = (stateData) => {
        if (stateData && stateData[customerIdToUse]) {

            try {

                const activeServicesDetails = techData
                && techData.totals
                    ?  techData.totals["active_services_detail"]
                    : null;

                //go through the activeServicesDetails and count ocurrance of each service name

                const arrayOfActiveServicesDetails = activeServicesDetails && Object.keys(activeServicesDetails).map((k) => activeServicesDetails[k]);
                const arrayServicesData = []
                const results = arrayOfActiveServicesDetails ? new BBObjectCounter(arrayOfActiveServicesDetails, x => x.port) : [];
                for (let [service, times] of results.entries()) {
                    // console.log("here is the for loop of services", service)
                    arrayServicesData.push(
                        {
                            name: service,
                            value: times
                        }
                    )
                }


                    return <div
                        className={"animated fadeIn animation-duration-7"}
                        id={"allPortsPieChartContainer"}
                        style={{ marginTop: -40, marginBottom: -15 }}
                    ><CustomActiveShapePieChart
                        data = {arrayServicesData}
                        loading={!activeServicesDetails}
                        // riskBy5={translateValueToRisk(valueFunction(stateData))}
                    /></div>

            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }


    const valueFunction = (stateData) => {
        const dataPointToDisplay = techData
        && techData.totals
            ? techData.totals.active_services_total
            : null;

        return <span id={"allPortsNum"}>{dataPointToDisplay}</span>;
    }

    return (
        <DataTile
            // color = {colorFunction()}
            // colorBgFunction={colorFunction}
            subTitle="Ports"
            tipText={`Breakdown of each port location detected.`}
            icon={<div
                className={"animated fadeIn animation-duration-7"}
                style={{ marginTop: -40, marginBottom: -15 }}
            ><CustomActiveShapePieChart
                data = {[]}
                // riskBy5={-1}
                loading
            /></div>}
            iconFunction = {showPieWith}
            iconClasses={" "}
            stateName="breachrisk"
            stateElement="portfolios"
            //useDeepDataStore
            dontFetch
            forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && techData && techData.meta && techData.meta.highestPageFetched >= techData.meta.pages ? false : true}
            // useDeepDataStore
            // dontFetch
            // forceLoadingState = {true}
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse] : null : null}
            // stateLoaderName="loadingTargets"
            // stateLoaderError="loadingTargetsError"
            // stateFetchAction={fetchTargets(
            //     {
            //         customerId: customerIdToUse
            //     }
            // )}
            // preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            // ribbonFunction={riskRibbon}
            // requiresModule={"monitor"}
        />
    )

}

export default Tile;